import { render, staticRenderFns } from "./settingFallback.vue?vue&type=template&id=13d50442&scoped=true"
import script from "./settingFallback.vue?vue&type=script&lang=ts"
export * from "./settingFallback.vue?vue&type=script&lang=ts"
import style0 from "./settingFallback.vue?vue&type=style&index=0&id=13d50442&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d50442",
  null
  
)

export default component.exports